module.exports = __webpack_public_path__ + "static/annual-report-2015-16-61d1a7c5755c067b81bd024557758c2c.pdf";